import React, { useCallback, useState } from 'react';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../utils/getCroppedImg';

const CropImagemCapa = ({ imagem, onCancel, onCropComplete }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const handleCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleConfirmCrop = async () => {
    const croppedImage = await getCroppedImg(imagem, croppedAreaPixels);
    onCropComplete(croppedImage);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
      <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-3xl">
        <h2 className="text-lg font-bold mb-4 text-center">
          Ajustar imagem de capa
        </h2>

        <div className="relative w-full h-72 bg-gray-200 rounded overflow-hidden">
          <Cropper
            image={imagem}
            crop={crop}
            zoom={zoom}
            aspect={16 / 9} // Capa: widescreen
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
          />
        </div>

        <div className="flex flex-col mt-4 space-y-2">
          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
          />
          <div className="flex justify-between">
            <button
              className="bg-gray-300 hover:bg-gray-400 text-black font-medium px-4 py-2 rounded"
              onClick={onCancel}
            >
              Cancelar
            </button>
            <button
              className="bg-blue-600 hover:bg-blue-800 text-white font-semibold px-4 py-2 rounded"
              onClick={handleConfirmCrop}
            >
              Recortar e Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CropImagemCapa;
